/* eslint-disable no-template-curly-in-string */
import { RouterBuilder } from 'alp-limosa/src';

export default (builder: RouterBuilder) => {
  builder.add('home', '/', 'home.index');
  builder.add('no-config', '/noconfig', 'no-config.index');
  builder.add('api-screen', '/api/screen', 'api-screen.index');
  builder.add('api-display', '/api/display/${action}', 'api-display.index');
};
